import type { ExternalTableSchema } from '@packages/table-builder';

export const vendorTermsConditionsTable: ExternalTableSchema = {
  metadata: {
    title: 'Vendor & Broker T&C',
    entity: 'VendorTermsAndConditions',
  },

  dataSource: {
    endpoint: '/api/customer/api/vendor-terms-and-conditions',
    method: 'GET',
    rowIdField: 'id',
  },

  columns: [
    { field: 'name', header: 'Name', type: 'text', width: 300 },
    { field: 'page', header: 'Page Name', type: 'text', width: 300 },
    {
      field: 'isActive',
      header: 'Status',
      type: 'badge',
      align: 'center',
      width: 200,
      uppercase: true,
      conditionalValues: { true: 'Active', false: 'Inactive' },
      badge: { statusMap: { true: 'success', false: 'error' }, defaultVariant: 'info' },
    },
    {
      field: 'agreementStatement',
      header: 'Agreement Statement',
      type: 'text',
      width: 300,
      visibility: 'picker',
    },
    {
      field: 'documentContent',
      header: 'Description',
      type: 'html',
      width: 300,
      visibility: 'picker',
    },
  ],

  actions: {
    toolbar: {
      primary: {
        id: 'ADD_VENDOR_TERMS_CONDITIONS',
        label: 'Add Terms & Conditions',
        icon: 'add_circle_outline',
      },
    },
    row: [
      { id: 'VIEW_VENDOR_TERMS_CONDITIONS', label: 'View' },
      { id: 'EDIT_VENDOR_TERMS_CONDITIONS', label: 'Edit' },
      { id: 'DELETE_VENDOR_TERMS_CONDITIONS', label: 'Delete', variant: 'danger' },
    ],
  },

  features: {
    search: { enabled: false },
    pagination: { mode: 'infiniteScroll', defaultSize: 10 },
    columnPreferences: { persistenceKey: 'Tnc', resizable: true, reorderable: true },
  },
};
